import { connectRefinementList } from 'instantsearch.js/es/connectors'

const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, widgetParams, refine } = renderOptions
  const container = $(widgetParams.container)
  // Hide the tags that are already selected
  const itemsToShow = items.filter(i => !i.isRefined)
  // If content types, only allow refining to 1 (each result only has 1 type)
  const hide = widgetParams.operator === 'or' && items.find(i => i.isRefined)
  if (itemsToShow.length && !hide) {
    container.html(`
      <h3>${widgetParams.title}</h3>
      <ul class="c-summary-list">
        ${itemsToShow.map(item => {
          const { label, value, count } = item
          const displayLabel = $(widgetParams.optionsSelector + ' option[value="' + value + '"]').data('title') || label
            return `
              <li class="c-summary-list__item">
                <a href="#" class="c-summary-list__link" data-value="${item.value}">
                  ${displayLabel} (${count})
                </a>
              </li>
            `
          }).join('')
        }
      </ul>
    `)
    container.css('display', 'block')

    container.find('a').each((i, element) => {
      element.addEventListener('click', event => {
        event.preventDefault()
        refine(event.currentTarget.dataset.value)
      })
    })
  } else {
    container.css('display', 'none')
  }
}

const customRefinementList = connectRefinementList(
  renderRefinementList
)

export default customRefinementList
